/* TG premium PDP controller.
 * Works with the theme's own engine (global.js VariantSelects, product-info.js,
 * product-form.js, pubsub.js). It never adds to cart itself: the sticky bar and
 * the nav mini button use the theme's real submit button.
 *
 * 1. Cascade (Condition -> Storage -> Colour): only valid values are offered;
 *    a change auto-selects the first valid value down the chain, "alt" colours
 *    switch grade/storage to the closest in-stock combination, "oos" colours are
 *    blocked with a WhatsApp toast. Runs in the capture phase, before the theme's
 *    VariantSelects reads the checked radios, so ?variant= and ATC stay correct.
 * 2. Sync: on the theme's variant-change pubsub event, copies every
 *    [data-tg-sync] node (price, stock) from the re-rendered section HTML.
 * 3. State: data-tg-unavailable on <product-info> hides ATC + dynamic checkout
 *    (CSS) and shows the WhatsApp link; ATC shows the price; sticky bar and nav
 *    mini price follow the variant; dispatches 'tg:variant' for tg-delivery.js.
 * 4. "Compare grades" panel toggle (survives option re-renders).
 * 5. Sticky bar reveal + section scrollspy.
 * 6. Policy drawer: [data-tg-open=tab] triggers, focus, Esc, scroll lock, tabs.
 * 7. Rotating warranty seal placed on the theme's gallery.
 */
(function () {
  if (window.tgPdpLoaded) return;
  window.tgPdpLoaded = true;

  var gradesOpen = false;
  // config + money (from #tg-config: shop.money_format, strings, WhatsApp number)
  var CFG = {};
  try { CFG = JSON.parse((document.getElementById('tg-config') || {}).textContent || '{}'); } catch (e) { CFG = {}; }
  var STR = CFG.strings || {};
  function formatMoney(cents, format) {
    var f = String(format || CFG.moneyFormat || '{{amount}}').replace(/<[^>]*>/g, '');
    var ph = /\{\{\s*(\w+)\s*\}\}/, m = f.match(ph);
    function n(c, prec, thou, dec) {
      thou = thou || ','; dec = dec || '.';
      var p = ((Number(c) || 0) / 100).toFixed(prec).split('.');
      return p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou) + (p[1] ? dec + p[1] : '');
    }
    var v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = n(cents, 0); break;
      case 'amount_with_comma_separator': v = n(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = n(cents, 0, '.', ','); break;
      default: v = n(cents, 2);
    }
    return f.replace(ph, v);
  }
  window.tgFormatMoney = formatMoney;
  var money = function (pence) { return formatMoney(pence); };
  function fill(t, map) { return String(t || '').replace(/\{(\w+)\}/g, function (a, k) { return k in map ? map[k] : a; }); }

  function productInfo() {
    var vs = document.querySelector('product-info variant-selects.tg-vs');
    return (vs && vs.closest('product-info')) || document.querySelector('product-info.tg-premium');
  }
  function currentVariant(pi) {
    var vs = pi && pi.querySelector('variant-selects.tg-vs');
    var s = vs && vs.querySelector('[data-selected-variant]');
    if (!s) return undefined; // single-variant product: nothing to read
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function selectionLabel(pi) {
    var vs = pi && pi.querySelector('variant-selects.tg-vs');
    if (!vs) return '';
    return Array.prototype.map.call(vs.querySelectorAll('input.tg-in:checked'), function (i) { return i.value; }).join(' · ');
  }
  function submitButton(pi) { return pi && pi.querySelector('product-form button[name="add"], product-form [type="submit"]'); }

  // 1. cascade (mockup v8 fix()/draw() + v9 colour rules)
  function vsModel(vs) {
    if (!vs._tgVariants) {
      try { vs._tgVariants = JSON.parse(vs.querySelector('[data-tg-variants]').textContent); } catch (e) { vs._tgVariants = []; }
    }
    var hidden = (vs.dataset.tgHiddenValues || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    var steps = Array.prototype.map.call(vs.querySelectorAll('fieldset.tg-step'), function (el) {
      return { el: el, idx: Number(el.dataset.tgIndex), kind: el.dataset.tgKind, inputs: Array.prototype.slice.call(el.querySelectorAll('input.tg-in')) };
    });
    var clean = vs._tgVariants.filter(function (v) {
      return v.available && !v.options.some(function (o) { return hidden.indexOf(String(o).toLowerCase().trim()) > -1; });
    });
    return { steps: steps, variants: clean, hidden: hidden };
  }
  function selOf(m) { return m.steps.map(function (st) { var c = st.inputs.filter(function (i) { return i.checked; })[0]; return c ? c.value : null; }); }
  function validAt(m, L, sel) { // value -> lowest price, honouring earlier levels
    var st = m.steps[L], out = {};
    m.variants.forEach(function (v) {
      for (var j = 0; j < L; j++) if (v.options[m.steps[j].idx] !== sel[j]) return;
      var val = v.options[st.idx];
      if (!(val in out) || v.price < out[val]) out[val] = v.price;
    });
    return out;
  }
  function check(st, value) { st.inputs.forEach(function (i) { if (i.value === value) i.checked = true; }); }
  function fix(m, from) { // keep the selection valid down the chain
    var sel = selOf(m);
    for (var L = from || 0; L < m.steps.length; L++) {
      var ok = validAt(m, L, sel), keys = m.steps[L].inputs.map(function (i) { return i.value; }).filter(function (v) { return v in ok; });
      if (!keys.length) return false;
      if (keys.indexOf(sel[L]) === -1) { sel[L] = keys[0]; check(m.steps[L], keys[0]); }
    }
    return true;
  }
  function render(vs) {
    var m = vsModel(vs), sel = selOf(m), onlyTxt = vs.dataset.tgOnlySize || 'only size in';
    var none = !m.variants.length; // nothing sellable at all
    var condSel = null;
    m.steps.forEach(function (st, L) { if (st.kind === 'condition') condSel = sel[L]; });
    m.steps.forEach(function (st, L) {
      var ok = validAt(m, L, sel), n = 0;
      st.inputs.forEach(function (inp) {
        var lab = st.el.querySelector('label[for="' + inp.id + '"]');
        if (!lab) return;
        var valid = inp.value in ok;
        if (st.kind === 'colour') {
          var any = m.variants.some(function (v) { return v.options[st.idx] === inp.value; });
          var state = valid ? 'ok' : (any ? 'alt' : 'oos');
          inp.dataset.tgState = state;
          lab.classList.toggle('is-alt', state === 'alt');
          lab.classList.toggle('is-oos', state === 'oos');
          var p = lab.querySelector('.tg-col__p');
          if (state === 'ok') { if (p) p.remove(); }
          else {
            if (!p) { p = document.createElement('span'); p.className = 'tg-col__p'; lab.appendChild(p); }
            var t = state === 'alt' ? (STR.otherSpec || '') : (STR.comingSoon || 'Coming soon');
            if (p.textContent !== t) p.textContent = t;
          }
          if (valid) n++;
        } else {
          var show = valid || (inp.checked && !none);
          var soon = false;
          if (!none && m.hidden.indexOf(String(inp.value).toLowerCase().trim()) === -1) { show = true; soon = !valid; } // out-of-stock sizes stay visible as "Coming soon"
          if (soon) inp.dataset.tgSoon = '1'; else delete inp.dataset.tgSoon;
          lab.classList.toggle('is-soon', soon);
          inp.hidden = !show; lab.hidden = !show;
          var pr = lab.querySelector('[data-tg-p]');
          if (pr) { var txt = valid ? (L === 0 ? 'from ' : '') + money(ok[inp.value]).replace(/\.00$/, '') : (soon ? (STR.comingSoon || 'Coming soon') : ''); if (pr.textContent !== txt) pr.textContent = txt; }
          if (valid || soon) n++;
        }
      });
      var list = st.el.querySelector('[data-tg-list]');
      if (list && st.kind !== 'colour') {
        var na = list.querySelector('.tg-na-row');
        if (none && !na) { na = document.createElement('p'); na.className = 'tg-na-row'; na.textContent = STR.unavailable || ''; list.appendChild(na); }
        if (!none && na) na.remove();
        var cls = 'tg-seg tg-seg--' + Math.min(Math.max(n, 1), 4);
        if (list.className !== cls) list.className = cls;
      }
      var vEl = st.el.querySelector('[data-tg-v]');
      if (vEl) {
        var label = none && st.kind !== 'colour' ? '—' : (sel[L] || '');
        if (st.kind === 'storage' && n === 1 && condSel) label += ' · ' + onlyTxt + ' ' + condSel;
        if (vEl.textContent !== label) vEl.textContent = label;
      }
      st.el.dataset.tgSel = sel[L] || '';
    });
  }
  function toast(vs, html) {
    var el = vs.parentNode && vs.parentNode.querySelector('[data-tg-toast]');
    if (!el) return;
    el.innerHTML = html; el.classList.add('is-show');
    clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('is-show'); }, /<a /.test(html) ? 9000 : 3800); // link toasts stay longer
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('variant-selects.tg-vs input.tg-in')) return;
    var vs = t.closest('variant-selects'), m = vsModel(vs);
    var L = m.steps.map(function (s) { return s.el; }).indexOf(t.closest('fieldset.tg-step'));
    if (L < 0) return;
    var st = m.steps[L];
    if (t.dataset.tgSoon) { // "Coming soon" size: keep the current selection, offer WhatsApp
      check(st, st.el.dataset.tgSel);
      e.stopPropagation();
      var sNum = CFG.whatsapp || '';
      var sTitle = CFG.productTitle || ((document.querySelector('.tg-h1') || {}).textContent || '').trim();
      var sWa = 'Hi, when will the ' + sTitle + ' in ' + t.value + ' be back in stock?';
      var sLink = sNum ? ' <a href="https://wa.me/' + sNum + '?text=' + encodeURIComponent(sWa) + '" target="_blank" rel="noopener">Ask on WhatsApp</a>' : '';
      toast(vs, esc(t.value) + ' is coming soon.' + sLink);
      return;
    }
    if (st.kind === 'colour') {
      var state = t.dataset.tgState || 'ok', short = t.dataset.tgLabel || t.value;
      if (state === 'oos') { // don't change the selection; offer WhatsApp
        check(st, st.el.dataset.tgSel);
        e.stopPropagation();
        var num = CFG.whatsapp || '';
        var title = CFG.productTitle || ((document.querySelector('.tg-h1') || {}).textContent || '').trim();
        var shortC = t.dataset.tgLabel || t.value;
        var waText = fill(STR.waOos || '', { product: title, colour: t.value });
        var link = num ? '<a href="https://wa.me/' + num + '?text=' + encodeURIComponent(waText) + '" target="_blank" rel="noopener">' + esc(STR.toastLink || '') + '</a>' : '';
        toast(vs, fill(esc(STR.toastOos || ''), { colour: esc(shortC), link: link }));
        return;
      }
      if (state === 'alt') { // closest in-stock combination: same earlier values first, then cheapest
        var sel = selOf(m), best = null, bestScore = 1e9;
        m.variants.forEach(function (v) {
          if (v.options[st.idx] !== t.value) return;
          var score = 0;
          for (var j = 0; j < L; j++) if (v.options[m.steps[j].idx] !== sel[j]) score += Math.pow(2, L - 1 - j);
          if (score < bestScore || (score === bestScore && v.price < best.price)) { best = v; bestScore = score; }
        });
        if (best) {
          var parts = [];
          for (var j = 0; j < L; j++) { check(m.steps[j], best.options[m.steps[j].idx]); parts.push(best.options[m.steps[j].idx]); }
          toast(vs, fill(esc(STR.toastSwitched || ''), { colour: esc(short), spec: '<b>' + esc(parts.join(' · ')) + '</b>' }));
        }
      }
    }
    var before = selOf(m);
    fix(m, 0);
    render(vs);
    if (st.kind !== 'colour') {
      var after = selOf(m), prev = [], now = [];
      m.steps.forEach(function (x, j) {
        if (j <= L || after[j] === before[j]) return;
        var lab = function (v) { var i = x.inputs.filter(function (q) { return q.value === v; })[0]; return (i && i.dataset.tgLabel) || v; };
        prev.push(lab(before[j])); now.push(lab(after[j]));
      });
      if (now.length) {
        var condStep = m.steps.filter(function (x) { return x.kind === 'condition'; })[0];
        var choice = condStep ? after[m.steps.indexOf(condStep)] : t.value;
        toast(vs, fill(esc(STR.toastColourAuto || ''), { prev: esc(prev.join(' ')), choice: esc(choice), new: '<b>' + esc(now.join(' · ')) + '</b>' }));
      }
    }
    applyBattery(vs.closest('product-info'));
  }, true);

  // 2a. keep keyboard focus on the same option after the theme swaps <variant-selects>
  var lastFocusId = null;
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    lastFocusId = t && t.matches && t.matches('variant-selects.tg-vs input.tg-in') ? t.dataset.optionValueId : null;
  });
  function restoreFocus(pi) {
    if (!lastFocusId) return;
    var a = document.activeElement;
    if (a && a !== document.body && a.isConnected && !a.closest('[style*="display: none"]')) return;
    var n = pi.querySelector('variant-selects.tg-vs input.tg-in[data-option-value-id="' + lastFocusId + '"]');
    if (n && !n.hidden) n.focus({ preventScroll: true });
  }

  // 2b. keep the cascade right after each server re-render (and on first load)
  function settle(pi, dispatch) {
    var vs = pi && pi.querySelector('variant-selects.tg-vs');
    if (!vs) return;
    var m = vsModel(vs), before = selOf(m).join('|');
    var ok = fix(m, 0);
    render(vs);
    if (dispatch && ok && selOf(m).join('|') !== before) {
      var changed = m.steps.map(function (s) { return s.inputs.filter(function (i) { return i.checked; })[0]; }).filter(Boolean)[0];
      if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function applyBattery(pi) {
    if (!pi) return;
    var specEl = document.querySelector('[data-tg-spec-line]'), lbl = selectionLabel(pi);
    if (specEl && lbl && specEl.textContent !== lbl) specEl.textContent = lbl;
    // per-grade battery (v15): .js-bat / .js-grade / [data-tg-ring]
    var vsEl = pi.querySelector('variant-selects.tg-vs');
    if (vsEl) {
      var batMap = {};
      try { batMap = JSON.parse(vsEl.dataset.tgBat || '{}'); } catch (e) {}
      var condStep = vsEl.querySelector('fieldset.tg-step[data-tg-kind="condition"]');
      var grade = condStep && condStep.querySelector('input.tg-in:checked') ? condStep.querySelector('input.tg-in:checked').value : '';
      var vals = Object.keys(batMap).map(function (k) { return batMap[k]; });
      var bat = grade && batMap[grade] ? batMap[grade] : (vals.length ? Math.min.apply(null, vals) : null);
      if (bat !== null) {
        document.querySelectorAll('.js-bat').forEach(function (n) { if (n.textContent !== String(bat)) n.textContent = bat; });
        document.querySelectorAll('[data-tg-ring]').forEach(function (n) { n.style.setProperty('--tg-bat', bat + '%'); });
      }
      if (grade) document.querySelectorAll('.js-grade').forEach(function (n) { if (n.textContent !== grade) n.textContent = grade; });
      // "Add to basket" wording on the theme's own button, without touching locales
      var atcLabel = STR.atc; // scoped to this page's button only; global variantStrings untouched
      var sb = submitButton(pi), sbText = sb && sb.querySelector('span');
      if (atcLabel && sb && !sb.disabled && sbText && sbText.textContent.trim() !== atcLabel) sbText.textContent = atcLabel;
    }

  }

  // 3. state
  function applyState() {
    var pi = productInfo();
    if (!pi) return;
    var variant = currentVariant(pi);
    var single = variant === undefined;
    var ok = single ? !(submitButton(pi) && submitButton(pi).disabled && !submitButton(pi).classList.contains('loading')) : !!(variant && variant.available);
    if (!single) pi.toggleAttribute('data-tg-unavailable', !ok);

    applyBattery(pi);

    var price = variant && typeof variant.price === 'number' ? variant.price : null;
    var btn = submitButton(pi);
    if (btn && price !== null) {
      var p = btn.querySelector('.tg-atc-p');
      if (!p) {
        var first = btn.querySelector('span');
        var sepEl = document.createElement('span'); sepEl.className = 'tg-atc-sep'; sepEl.setAttribute('aria-hidden', 'true');
        p = document.createElement('span'); p.className = 'tg-atc-p';
        if (first && first.nextSibling) { btn.insertBefore(sepEl, first.nextSibling); btn.insertBefore(p, sepEl.nextSibling); }
        else { btn.appendChild(sepEl); btn.appendChild(p); }
      }
      if (p.textContent !== money(price)) p.textContent = money(price);
    }

    var label = selectionLabel(pi) || (variant && variant.title) || '';
    var spec = document.querySelector('[data-tg-spec-line]');
    if (spec && label && spec.textContent !== label) spec.textContent = label;
    var title = (document.querySelector('.tg-h1') || {}).textContent || '';
    document.querySelectorAll('a[data-tg-wa-prefix]').forEach(function (a) {
      var msg = (a.dataset.tgWaPrefix + ' ' + title.trim() + (label && !single ? ' (' + label + ')' : '')).trim();
      if (!a.dataset.tgWaNum) { a.hidden = true; return; }
      var href = 'https://wa.me/' + a.dataset.tgWaNum + '?text=' + encodeURIComponent(msg);
      if (a.getAttribute('href') !== href) a.setAttribute('href', href);
    });
    if (!ok && !single && !variant) {
      var st = pi.querySelector('[data-tg-sync="stock"] .tg-stock');
      if (st) st.classList.add('is-out');
    }

    var bar = document.querySelector('[data-tg-bar]');
    if (bar) {
      var bv = bar.querySelector('[data-tg-bar-var]'); if (bv && label && bv.textContent !== ' · ' + label) bv.textContent = ' · ' + label;
      var bp = bar.querySelector('[data-tg-bar-price]'); if (bp && price !== null) bp.textContent = money(price);
      var add = bar.querySelector('[data-tg-bar-add]'), bask = bar.querySelector('[data-tg-bar-ask]');
      if (add) add.hidden = !ok;
      if (bask) bask.hidden = ok;
      var img = bar.querySelector('[data-tg-bar-img] img');
      if (img && variant && variant.featured_image && variant.featured_image.src) {
        var src = variant.featured_image.src; src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=100';
        img.removeAttribute('srcset'); img.src = src;
      }
    }
    var mini = document.querySelector('[data-tg-mini-price]');
    if (mini && price !== null) mini.textContent = money(price);
    var miniAdd = document.querySelector('[data-tg-mini-add]');
    if (miniAdd) miniAdd.hidden = !ok;

    var gp = pi.querySelector('[data-tg-gpop]'), gb = pi.querySelector('[data-tg-gbtn]');
    if (gp && gb) setGrades(gp, gb, gradesOpen);

    document.dispatchEvent(new CustomEvent('tg:variant', { detail: { variant: variant || null, available: ok } }));
  }

  // 2. sync from the theme's section re-render
  function onVariantChange(evt) {
    var data = evt && evt.data;
    var pi = productInfo();
    if (!pi || (data && data.sectionId && data.sectionId !== (pi.dataset.originalSection || pi.dataset.section))) return;
    if (data && data.html && pi) {
      pi.querySelectorAll('[data-tg-sync]').forEach(function (node) {
        var src = data.html.querySelector('[data-tg-sync="' + node.dataset.tgSync + '"]');
        if (src) node.innerHTML = src.innerHTML;
      });
    }
    applyState();
  }

  // 4. compare grades
  function setGrades(gp, gb, open) {
    if (gp.hidden !== !open) gp.hidden = !open;
    gb.setAttribute('aria-expanded', open ? 'true' : 'false');
    var lbl = open ? gb.dataset.openLabel : gb.dataset.closedLabel;
    if (gb.textContent !== lbl) gb.textContent = lbl; // guarded: MutationObserver watches this subtree
  }
  document.addEventListener('click', function (e) {
    var gb = e.target.closest && e.target.closest('[data-tg-gbtn]');
    if (gb) {
      var gp = gb.closest('.tg-step').querySelector('[data-tg-gpop]');
      if (gp) { gradesOpen = gp.hidden; setGrades(gp, gb, gradesOpen); }
      return;
    }
    var bar = e.target.closest && e.target.closest('[data-tg-bar-add]');
    if (bar) {
      var btn = submitButton(productInfo());
      if (btn && !btn.disabled) btn.click();
      return;
    }
    var mini = e.target.closest && e.target.closest('[data-tg-mini-add], .tg-snav a[href^="#"]');
    if (mini) {
      var id = mini.getAttribute('href').slice(1), target = document.getElementById(id);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); history.replaceState(null, '', '#' + id); }
    }
  });

  // 5. sticky bar + scrollspy + sticky offset under a sticky theme header
  function initScroll() {
    var pi = productInfo();
    var bar = document.querySelector('[data-tg-bar]');
    var anchor = pi && (pi.querySelector('.product-form__buttons') || pi.querySelector('product-form'));
    var mini = document.querySelector('.tg-snav__mini');
    var mq = window.matchMedia ? window.matchMedia('(max-width: 760px)') : { matches: false };
    if (bar && anchor && 'IntersectionObserver' in window) {
      var lastE = null;
      var apply = function () {
        if (!lastE) return;
        var past = !lastE.isIntersecting && lastE.boundingClientRect.top < 0;
        var show = mq.matches ? !lastE.isIntersecting : past;
        bar.classList.toggle('is-show', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.querySelectorAll('a,button').forEach(function (n) { n.tabIndex = show ? 0 : -1; });
        if (mini) mini.classList.toggle('is-off', past || mq.matches); // only one sticky buy element at a time
        document.body.style.paddingBottom = (show && mq.matches) ? (bar.offsetHeight + 8) + 'px' : '';
      };
      new IntersectionObserver(function (es) { lastE = es[0]; apply(); }).observe(anchor);
      // rAF scroll fallback above 760px (IntersectionObserver can miss fast flings past the buttons)
      var rq = 0;
      window.addEventListener('scroll', function () {
        if (rq || mq.matches) return;
        rq = requestAnimationFrame(function () {
          rq = 0;
          var rect = anchor.getBoundingClientRect();
          lastE = { isIntersecting: rect.bottom > 0 && rect.top < window.innerHeight, boundingClientRect: rect };
          apply();
        });
      }, { passive: true });
      if (mq.addEventListener) mq.addEventListener('change', apply);
    }
    var links = Array.prototype.slice.call(document.querySelectorAll('.tg-snav .tg-wrap > a[href^="#"]'));
    if (links.length && 'IntersectionObserver' in window) {
      var spy = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (a) {
            var on = a.getAttribute('href') === '#' + e.target.id;
            a.classList.toggle('is-on', on);
            if (on) { var c = a.parentElement; c.scrollTo({ left: a.offsetLeft - (c.clientWidth - a.clientWidth) / 2, behavior: 'smooth' }); }
          });
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      document.querySelectorAll('.tg-story .tg-sec[id]').forEach(function (s) { spy.observe(s); });
    }
    var hdr = document.querySelector('.shopify-section-header-sticky');
    var storyRoot = document.querySelector('.tg-story');
    if (hdr && storyRoot) {
      var ticking = false, lastTop = null;
      var onScroll = function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var v = Math.max(0, hdr.getBoundingClientRect().bottom);
          if (v !== lastTop) { lastTop = v; storyRoot.style.setProperty('--tg-snav-top', v + 'px'); }
        });
      };
      onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  // 6. policy drawer (moved to <body> so no transformed ancestor breaks position:fixed)
  var drawer = null, scrim = null, lastFocus = null;
  function setupDrawer() {
    drawer = document.querySelector('[data-tg-drawer]');
    scrim = document.querySelector('[data-tg-scrim]');
    if (!drawer) {
      document.querySelectorAll('.tg-story [data-tg-open]').forEach(function (b) { b.hidden = true; });
      return;
    }
    [scrim, drawer].forEach(function (n) {
      if (!n) return;
      n.classList.add('tg-root');
      document.body.appendChild(n);
    });
    if (scrim) scrim.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-tg-close]')) { closeDrawer(); return; }
      var tb = e.target.closest('[data-tg-tab]');
      if (tb) showTab(tb.dataset.tgTab);
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
      if (e.key === 'Tab') { // keep focus inside the dialog
        var f = drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])');
        f = Array.prototype.filter.call(f, function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      if (e.target.matches('[role="tab"]') && ['ArrowRight', 'ArrowLeft', 'Home', 'End'].indexOf(e.key) > -1) {
        e.preventDefault();
        var tabs = Array.prototype.slice.call(drawer.querySelectorAll('[data-tg-tab]'));
        var i = tabs.indexOf(e.target) + (e.key === 'ArrowRight' ? 1 : -1);
        var next = e.key === 'Home' ? tabs[0] : e.key === 'End' ? tabs[tabs.length - 1] : tabs[(i + tabs.length) % tabs.length];
        showTab(next.dataset.tgTab); next.focus();
      }
    });
  }
  function showTab(k) {
    if (!drawer) return;
    if (!drawer.querySelector('[data-tg-pane="' + k + '"]')) {
      var firstTab = drawer.querySelector('[data-tg-tab]');
      k = firstTab ? firstTab.dataset.tgTab : k;
    }
    drawer.querySelectorAll('[data-tg-tab]').forEach(function (b) {
      var on = b.dataset.tgTab === k;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      if (on) { var c = b.parentElement; c.scrollTo({ left: b.offsetLeft - (c.clientWidth - b.clientWidth) / 2 }); }
    });
    drawer.querySelectorAll('[data-tg-pane]').forEach(function (p) { p.classList.toggle('is-on', p.dataset.tgPane === k); });
  }
  function openDrawer(tab) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    showTab(tab);
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('is-open'); }); }
    drawer.inert = false; drawer.removeAttribute('inert');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tg-lock');
    var x = drawer.querySelector('[data-tg-close]');
    if (x) setTimeout(function () { x.focus(); }, 30);
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true; drawer.setAttribute('inert', '');
    if (scrim) { scrim.classList.remove('is-open'); setTimeout(function () { scrim.hidden = true; }, 300); }
    document.documentElement.classList.remove('tg-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-tg-open]');
    if (o && drawer) { e.preventDefault(); openDrawer(o.dataset.tgOpen); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  // 7. gallery stage (mockup layout on top of the theme's media-gallery, lightbox and video untouched):
  //    badge, "1 / N" counter, zoom button (opens the theme's own lightbox) and the rotating seal.
  function stageViewer() {
    var pi = productInfo();
    var gal = pi && pi.querySelector('media-gallery');
    return gal ? (gal.querySelector('[id^="GalleryViewer"]') || gal) : (pi && pi.querySelector('.product__media-wrapper'));
  }
  function mediaItems(viewer) { return Array.prototype.slice.call(viewer.querySelectorAll('li[data-media-id]')); }
  function activeItem(viewer) {
    var items = mediaItems(viewer);
    return viewer.querySelector('li[data-media-id].is-active') || items[0] || null;
  }
  function updateCount(viewer, page) {
    var c = viewer.querySelector('[data-tg-count]'); if (!c) return;
    var items = mediaItems(viewer), n = items.length;
    if (n < 2) { c.hidden = true; return; }
    var i = page ? page : items.indexOf(activeItem(viewer)) + 1;
    var t = Math.max(1, i) + ' / ' + n;
    if (c.textContent !== t) c.textContent = t;
  }
  function placeSeal() {
    var viewer = stageViewer();
    if (!viewer) return;
    viewer.classList.add('tg-has-seal', 'tg-stage');
    var st = document.querySelector('template[data-tg-stage-tpl]');
    if (st && !viewer.querySelector('[data-tg-count]')) {
      viewer.appendChild(st.content.cloneNode(true));
      updateCount(viewer);
      new MutationObserver(function () { updateCount(viewer); }).observe(viewer, { attributes: true, attributeFilter: ['class'], subtree: true });
      viewer.addEventListener('slideChanged', function (e) { updateCount(viewer, e.detail && e.detail.currentPage); });
      viewer.addEventListener('click', function (e) {
        if (!e.target.closest('[data-tg-zoom]')) return;
        var a = activeItem(viewer), toggle = a && a.querySelector('.product__media-toggle');
        if (toggle) toggle.click();
      });
    }
    var tpl = document.querySelector('template[data-tg-seal-tpl]');
    if (tpl && !viewer.querySelector('.tg-seal')) viewer.appendChild(tpl.content.cloneNode(true));
  }

  function init() {
    var pi = productInfo();
    setupDrawer();
    placeSeal();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
    // variant-selects is swapped on every change; also catches the "no such variant" path
    if (pi && 'MutationObserver' in window) {
      var queued = false;
      new MutationObserver(function (records) {
        var hit = records.some(function (r) {
          return Array.prototype.some.call(r.addedNodes, function (n) {
            return n.nodeType === 1 && (n.matches('variant-selects') || (n.querySelector && n.querySelector('variant-selects')));
          });
        });
        if (!hit) return;
        settle(pi, true); // synchronous, before paint; only dispatches if the selection had to change
        restoreFocus(pi);
        if (queued) return; queued = true;
        requestAnimationFrame(function () { queued = false; applyState(); });
      }).observe(pi, { childList: true, subtree: true });
    }
    settle(pi, true);
    applyState();
    initScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
